import React from 'react';
import { Edit3 } from 'lucide-react';

interface EditButtonProps {
  onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
  variant?: 'primary' | 'secondary' | 'ghost';
  className?: string;
  title?: string;
  'aria-label'?: string;
}

const EditButton: React.FC<EditButtonProps> = ({
  onClick,
  disabled = false,
  size = 'md',
  variant = 'primary',
  className = '',
  title = 'Edit',
  'aria-label': ariaLabel = 'Edit'
}) => {
  const baseClasses = 'inline-flex items-center justify-center rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  
  const sizeClasses = {
    sm: 'p-1.5',
    md: 'p-2',
    lg: 'p-3'
  };
  
  const variantClasses = {
    primary: 'text-primary hover:text-primary-dark hover:bg-primary/10 focus:ring-primary/30',
    secondary: 'text-slate-600 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-700 focus:ring-slate-500/30',
    ghost: 'text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-700 focus:ring-slate-500/30'
  };
  
  const iconSizes = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-5 h-5'
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${className}`}
      title={title}
      aria-label={ariaLabel}
      type="button"
    >
      <Edit3 className={iconSizes[size]} />
    </button>
  );
};

export default EditButton;

